import { useTranslation } from '@/locales';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import { DocumentationHeaderPermitted } from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/DocumentationHeader/DocumentationHeaderPermitted';
import {
  StyledBasicToolbar,
  StyledHeader,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';

export const DocumentationHeader = () => {
  const { t } = useTranslation('common');
  const { shouldDisplayDocumentation } = usePermissionsManager();
  const { isDesktop } = useBreakpointsCtx();

  if (!shouldDisplayDocumentation) {
    return (
      <StyledHeader position="static" isDesktop={isDesktop}>
        <StyledBasicToolbar>
          <StyledAgioH1
            noWrap
            color="customSecondary.primary.DEFAULT"
            data-testid="documentation-header-title"
          >
            {t('documentation.header.title')}
          </StyledAgioH1>
        </StyledBasicToolbar>
      </StyledHeader>
    );
  }

  return <DocumentationHeaderPermitted />;
};
